// msg_sent 
import selfHtml from './s42-msg_sent.html' with { type: 'text' };;
import templateHtml from './t01-avatars.html' with { type: 'text' };

import { mod_loader, BASEURL, ShareModule } from "../AppState.js"
import { get_pub_key } from "../crypt_helper.js";
import { getUserAvatar, styleAvatar } from "../utils.js";


var url_encrypted_link

var root

export async function init(module_root, args) {

    module_root.innerHTML = selfHtml;

    root = module_root;

    $e(root).getEl("templates_container").innerHTML = templateHtml;

    var rcpt_address = "";
    var rcpt_pub_key_str = "";

    if (args.data.psk_password) {
        url_encrypted_link = BASEURL.www + "/?id=" + args.data.hash + "#" + args.data.psk_password;
        rcpt_address = "Anhone with the link";
        root.querySelectorAll(".safe_async_security").forEach(el => el.style.display = "none");

        root.querySelector(".recipient_address").innerText = "Anyone with this link can decrypt the message"
    } else {
        url_encrypted_link = BASEURL.www + "/?id=" + args.data.hash;

        root.querySelector(".recipient_address").innerText = "";

        for (const i in args.data.recp_address) {
            const rcpt_pub_key = await get_pub_key(args.data.recp_address[i]);
            rcpt_address += " " + rcpt_pub_key.myKeyPairUserID[0];
            rcpt_pub_key_str += " " + rcpt_pub_key.myKeyPairKeyID;

            // build the avatar
            const tpl_endorser = $e(root).getEl("tpl-badge-endorser");
            const node = tpl_endorser.content.cloneNode(true);
            const badge = node.querySelector("span.badge");
            badge.style.background = "#f0f4ff";
            badge.style.color = "#1a1a2e";
            styleAvatar(node.querySelector(".avatar"), { fullname: rcpt_pub_key.myKeyPairUserID[0], pgp_pubkey: rcpt_pub_key.myKeyPairPublicKey }, 22);
            node.querySelector(".name").textContent = rcpt_pub_key.myKeyPairUserID[0];
            root.querySelector(".recipient_address").appendChild(node);

        }

        root.querySelectorAll(".unsafe_psk_security").forEach(el => el.style.display = "none");
        // root.querySelector(".recipient_address").innerText = rcpt_address + " -- TODO: make avatars";
    }

    root.querySelector(".sender_address").innerText = args.data.sender_address.myKeyPairUserID[0]


    const description_why_to_shate = "Hey, you can download the secret message at the URL below." +
        "\nFor security reason, this link has only a limited time duration.\n" +
        "The encryption is end-to-end at client side, and is verifiable with any PGP software."

    const shareData = {
        title: "Encrypted message from " + args.data.sender_address.myKeyPairUserID[0],
        text: description_why_to_shate,
        url: url_encrypted_link
    };

    mod_loader(ShareModule, { target: ".div_show_encrypted_link_section", active_link: url_encrypted_link, shareData });
}
